@file:OptIn(InternalResourceApi::class)

package quip.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/quip.composeapp.generated.resources/"

public val Res.string.vehicle_type_bus: StringResource by lazy {
      StringResource("string:vehicle_type_bus", "vehicle_type_bus", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23107, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24819, 36),
      ))
    }

public val Res.string.vehicle_type_car: StringResource by lazy {
      StringResource("string:vehicle_type_car", "vehicle_type_car", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23136, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24856, 32),
      ))
    }

public val Res.string.vehicle_type_motorcycle: StringResource by lazy {
      StringResource("string:vehicle_type_motorcycle", "vehicle_type_motorcycle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23165, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24889, 39),
      ))
    }

public val Res.string.vehicle_type_other: StringResource by lazy {
      StringResource("string:vehicle_type_other", "vehicle_type_other", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23213, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24929, 34),
      ))
    }

public val Res.string.vehicle_type_truck: StringResource by lazy {
      StringResource("string:vehicle_type_truck", "vehicle_type_truck", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23248, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24964, 38),
      ))
    }

public val Res.string.vehicle_type_van: StringResource by lazy {
      StringResource("string:vehicle_type_van", "vehicle_type_van", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23283, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25003, 36),
      ))
    }

public val Res.string.vehicle_updated_successfully: StringResource by lazy {
      StringResource("string:vehicle_updated_successfully", "vehicle_updated_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23349, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25085, 84),
      ))
    }

public val Res.string.vin: StringResource by lazy {
      StringResource("string:vin", "vin", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23454, 15),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25198, 15),
      ))
    }

public val Res.string.workshop: StringResource by lazy {
      StringResource("string:workshop", "workshop", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23470, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25214, 24),
      ))
    }

public val Res.string.year: StringResource by lazy {
      StringResource("string:year", "year", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23499, 20),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25239, 20),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("vehicle_type_bus", Res.string.vehicle_type_bus)
  map.put("vehicle_type_car", Res.string.vehicle_type_car)
  map.put("vehicle_type_motorcycle", Res.string.vehicle_type_motorcycle)
  map.put("vehicle_type_other", Res.string.vehicle_type_other)
  map.put("vehicle_type_truck", Res.string.vehicle_type_truck)
  map.put("vehicle_type_van", Res.string.vehicle_type_van)
  map.put("vehicle_updated_successfully", Res.string.vehicle_updated_successfully)
  map.put("vin", Res.string.vin)
  map.put("workshop", Res.string.workshop)
  map.put("year", Res.string.year)
}
